<template src="./html/Index.html"></template>

<script>
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Index.vue